import React from 'react'
import button from "../assets/button.png"
import button2 from "../assets/button2.png"
import topbird from "../assets/topbird.gif"

const HeroSection = () => {
    return (
        <>
        <main className='flex items-center justify-between md:flex-row flex-col'>
   <div className='md:w-[50%] w-screen flex items-center justify-center flex-col relative'>
    <img src={topbird} alt="" className='md:h-32 md:w-32 h-16 w-16 absolute md:right-10 right-5 top-0 -rotate-12'/>
      <h1 className='text-shadow'>Join FLAPPY</h1>
      <h1 className='text-shadow'>Pre-Sale Today</h1>
      <p className='text-xl md:w-[65%] w-full md:px-0 px-5 font-bold'>Buy more than 50.000 $fLAPPY and get an extra 10% Bonus</p>
    <div className='flex items-center mt-5 w-full md:ml-[40%] ml-[10%]'>
     <a href='/'>
      <img src={button} alt='' className='h-[60%] w-[60%]'/>
      </a>
      <a href='/' className='relative -ml-16'>
      <img src={button2} alt='' className='h-[60%] w-[60%]'/>
      <span className='absolute left-[10%] top-[10%]'>Learn More</span>
      </a>
      </div>
    </div>
    <div className=' md:flex md:flex-row flex-col md:w-[50%] items-center justify-center'>
    <iframe
    className='md:h-96 md:w-96 h-52 w-52 mt-5'
    title='countdown'
            allow="clipboard-read; clipboard-write"
            src="https://cryptohub.investments/embeded/presale/8453/0xae527908a3cfe4d642b3de9c8244e86734e653eb?&&&"
            frameborder="0"></iframe>
    </div>

    </main>
    <div className='flex items-center justify-between md:w-2/6 w-2/3 md:ml-[8rem] -mt-12 md:mt-0'>
      <img src={topbird} alt="" className='h-16 w-16'/>
      <img src={topbird} alt="" className='h-32 w-32 md:-mt-36'/>
      </div>
        </>
    )
}

export default HeroSection
